import gsap from "gsap"
import style from './Tokenomics.module.css'
import { useEffect } from "react"
import logo from '../assets/Your paragraph text.png';
import chart from '../assets/tokenomicschart.png'


export default function Tokenomics()
{
    useEffect(() => {
        gsap.fromTo("#flashingText", {color: 'red',}, {color: "yellow", repeat: -1, yoyo: 'true'})
        gsap.fromTo("#flashingText", {x: -500}, {x: 500, repeat: -1, yoyo: 'true', duration: 10})
    })

    return(
        <div className = {style.Container}>
            <h2>TOKENOMICS</h2>
            <h2>1) There is only 1 salamander token it is shared (for love). </h2>
            <h2>1) Everyoneg ets a piece, so there will become peace - Bhakjirat Shinjutsu. </h2>
            <h2>1)Official address of tokens: will go here </h2>
            <h2>1) Copy cats will be persecuted, we will hire the bounty hunters</h2>
            <h2 style = {{color: "red"}}>💯CERTIFIED BY BONES SECURITY💯</h2>

            <img className={style.Img} src = {logo} />

            <h2 className={style.Header} id = "flashingText">Tokenomic </h2>
            <img src = {chart} alt = "tokenomics chart" />
        </div>
    )
}